import BaseModel from '@/orm/models/BaseModel';

export default class Transaction extends BaseModel {
  static entity = 'transactions';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      debit: this.attr(null),
      credit: this.attr(null),
      balance: this.attr(null),
      description: this.string(null),
      type: this.string(null),
      itemType: this.string(null),
      date: this.string(null),
    };
  }

  static state() {
    return {
      total: 0,
      perPage: 15,
      currentPage: 0,
      lastPage: 0,
    };
  }

  static async index(params) {
    const request = await this.api().fetchAll(params);

    const { data, meta } = request.response.data;

    const entities = await this.insert({ data });

    await this.commit((state) => {
      state.total = meta.total;
      state.perPage = meta.per_page;
      state.currentPage = meta.current_page;
      state.lastPage = meta.last_page;
    });

    return entities;
  }

  static getMetaData() {
    const {
      total, perPage, currentPage, lastPage,
    } = this.store().state.entities[this.entity];
    return {
      total, perPage, currentPage, lastPage,
    };
  }

  static apiConfig = {
    actions: {
      fetchAll(params) {
        const { perPageValue, pageValue } = params;
        return this.get('accounting/transactions', {
          params: {
            perPage: perPageValue ?? 15,
            page: pageValue ?? 0,
          },
        });
      },
    },
  }
}
